import { useEffect, useState } from 'react';
import { ShieldAlert, Save, X } from 'lucide-react';
import { exportJSON } from '../lib/exporters';

const DAY = 864e5;
const has = (p) => (p.pipes?.length || 0) + (p.fittings?.length || 0) + (p.photos?.length || 0) + (p.plans?.length || 0) + (p.reports || []).reduce((s, r) => s + (r.photos?.length || 0), 0) > 0;

// data lives only on the device: remind to save a .giss backup after 3 days of unsaved work
export default function BackupReminder({ t, project }) {
  const [show, setShow] = useState(false);
  const id = project?.id;
  useEffect(() => {
    setShow(false);
    if (!id) return undefined;
    const tm = setTimeout(() => {
      const last = +localStorage.getItem(`giss_bak_${id}`) || 0, snooze = +localStorage.getItem(`giss_baksnooze_${id}`) || 0, now = Date.now();
      if (has(project) && (project.updatedAt || 0) > last && now - Math.max(last, project.createdAt || now) > 3 * DAY && now > snooze) setShow(true);
    }, 5000);
    return () => clearTimeout(tm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (!show) return null;
  const later = () => { localStorage.setItem(`giss_baksnooze_${id}`, String(Date.now() + DAY)); setShow(false); };
  return (
    <div className="bak-rem" role="alert" data-testid="backup-reminder">
      <ShieldAlert size={22} />
      <div><b>{t.bkTitle}</b><p>{t.bkText}</p></div>
      <div className="bak-btns">
        <button className="btn btn-green btn-sm" data-testid="backup-now-btn" onClick={async () => { await exportJSON(project); setShow(false); }}><Save size={14} /> {t.bkNow}</button>
        <button className="btn btn-outline btn-sm" data-testid="backup-later-btn" onClick={later}>{t.bkLater}</button>
      </div>
      <button className="icon-btn" data-testid="backup-close-btn" aria-label={t.bkLater} onClick={later}><X size={15} /></button>
    </div>
  );
}
